const rankings = [
  { rank: 1, title: '霸道总裁的契约新娘', tag: '韩漫·恋爱', heat: '362万', trend: 'up', change: '+3' },
  { rank: 2, title: '剑与魔法的异世界', tag: '日漫·热血', heat: '458万', trend: 'up', change: '+5' },
  { rank: 3, title: '修仙大佬在现代', tag: '国漫·奇幻', heat: '289万', trend: 'up', change: '+2' },
  { rank: 4, title: '我们的青春物语', tag: '日漫·校园', heat: '215万', trend: 'down', change: '-1' },
  { rank: 5, title: '暗夜追踪者', tag: '韩漫·悬疑', heat: '176万', trend: 'up', change: '+8' },
];

const medalColors = ['bg-accent-500', 'bg-secondary-400', 'bg-primary-400'];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-12 md:py-16 bg-background-100/50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 text-center mb-8">
          人气榜单
        </h2>

        <div className="space-y-3">
          {rankings.map((item, i) => (
            <a
              key={item.title}
              href="#"
              onClick={(e) => e.preventDefault()}
              className="flex items-center gap-4 p-4 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-200/60 hover:bg-primary-50/20 transition-all cursor-pointer group"
            >
              <div className={`w-8 h-8 md:w-10 md:h-10 rounded-xl flex items-center justify-center text-sm md:text-base font-bold ${
                i < 3
                  ? `${medalColors[i]} text-background-50`
                  : 'bg-secondary-100 text-secondary-600'
              }`}>
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors truncate">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 mt-0.5">{item.tag}</p>
              </div>
              <div className="flex items-center gap-1 text-xs font-medium">
                <span className={`${item.trend === 'up' ? 'text-primary-600' : 'text-foreground-400'}`}>
                  {item.change}
                </span>
              </div>
              <div className="text-right flex-shrink-0">
                <p className="text-sm font-semibold text-primary-600">
                  <i className="ri-fire-line mr-1 text-xs"></i>{item.heat}
                </p>
                <p className="text-xs text-foreground-400">热度</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}